<template>
    <div>
        <v-data-table dense :headers="orderHeaders" :items="orders" item-key="OrderID" :items-per-page="-1"
            :disable-pagination="true" :hide-default-footer="true" style="min-height: 200px">
            <template v-slot:body="props">
                <draggable :disabled="shiftDetail.DispatchFinalize" v-model="orders" group="OrderID"
                    @update="reorderLoads(1)" @add="addOrder" @remove="removeOrder" @start="onDragStart"
                    @dragenter="onDragListener" style="min-height: 200px;padding: 20px;" :delay="0" ghost-class="ghost"
                    animation="100" tag="tbody">
                    <tr v-for="(order, index) in props.items" :key="order.OrderID" class="py-2"
                        :class="order.OrdLoadStatus === 'DONE' ? '' : ''"
                        :style="order.FinalizeOrder == 1 ? 'backgroundColor:#DDD' : 'backgroundColor:' + orderColor(order)"
                        @contextmenu.prevent="openContextMenu(order, $event)">
                        <td class="custom-cell">
                            <v-icon :class="order.OrdLoadStatus === 'INPROGRESS'
                                ? 'bouncing'
                                : ''
                                " :color="getOrderLoadStatus(order, 'color')" class="my-2 pa-0 ml-0">
                                {{ getOrderLoadStatus(order, 'icon') }}
                            </v-icon>
                        </td>
                        <td class="custom-cell">
                            <v-icon :color="getOrderLoadStatus(order, 'color')">
                                mdi-numeric-{{ order.LoadNum }}-box
                            </v-icon>
                        </td>
                        <td class="custom-cell">
                            <v-icon :style="order.LoadNumOrd ? '' : 'opacity: 0.2;'"
                                :color="getOrderLoadStatus(order, 'color')">
                                mdi-numeric-{{ order.LoadNumOrd || 0 }}-box
                            </v-icon>
                        </td>
                        <td class="custom-cell">
                            {{ order.OrderID }}
                            <br />
                            <span v-if="order.OrderStatus != 'DISPATCHED'" class="font-weight-bold" :class="order.OrderStatus == 'PRLDISPAT'
                                ? 'green--text'
                                : order.OrderStatus == 'PRELOAD'
                                    ? 'orange--text'
                                    : ''
                                " style="font-size: 9px;">
                                {{
                                    order.OrderStatus == 'PRLDISPAT'
                                        ? 'PREDISPATCH'
                                        : order.OrderStatus
                                }}
                            </span>
                        </td>
                        <td class="custom-cell">
                            <v-chip class="ml-2 my-2 " label>
                                <v-avatar class="py-2" left tile :color="order.terminal?.Color || 'grey'">
                                    <v-icon small dark>mdi-water-pump</v-icon>
                                </v-avatar>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span class="location"
                                            style="width: 130px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                            v-on="on">
                                            {{ order.terminal.TerminalName }}
                                        </span>
                                    </template>
                                    <span>
                                        <v-icon small left :color="order.terminal?.Color || 'grey'
                                            ">
                                            mdi-water-pump
                                        </v-icon>
                                        {{ order.terminal.TerminalName }}
                                    </span>
                                </v-tooltip>
                            </v-chip>
                        </td>
                        <td class="custom-cell">
                            <v-chip class="ml-2 my-2" label>
                                <v-avatar class="py-2" left tile color="green ">
                                    <v-icon small dark>mdi-gas-station</v-icon>
                                </v-avatar>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span class="location" style="width: 130px;font-stretch: condensed;" v-on="on">
                                            {{ order.station.Name }}
                                        </span>
                                    </template>
                                    <span>
                                        <v-icon small left color="green lighten-3">mdi-gas-station</v-icon>
                                        {{ order.station.Name }}
                                    </span>
                                </v-tooltip>
                            </v-chip>
                        </td>
                        <td class="custom-cell">{{ order.station.City }}</td>
                        <td class="custom-cell">
                            <v-btn v-if="order" small text :style="{
                                color: checkTrailerCapacity(
                                    getOrderQuantities(order),
                                    'color'
                                )
                            }" class="font-weight-bold ma-0 pa-0" :class="checkTrailerCapacity(
                                getOrderQuantities(order),
                                'boolean'
                            )
                                ? ''
                                : 'pulsing'
                                " @click="openAutoAssignQuantities(order)" :disabled="order.Finalize == 1 ||
                                    order.OrdLoadStatus == 'DONE'
                                    ">
                                {{
                                    formatLargeNumber(getOrderQuantities(order))
                                }}
                                Lts.
                            </v-btn>
                        </td>
                        <td class="custom-cell">
                            <v-tooltip top>
                                <template v-slot:activator="{
                                    on,
                                    attrs
                                }">
                                    <span v-bind="attrs
                                        " v-on="on"
                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                        {{
                                            order.RTHrs
                                        }}
                                    </span>
                                </template>
                                <span>
                                    {{
                                        order.RTTime
                                    }}
                                </span>
                            </v-tooltip>
                        </td>
                        <td class="custom-cell">
                            <v-tooltip top>
                                <template v-slot:activator="{
                                    on,
                                    attrs
                                }">
                                    <span v-bind="attrs
                                        " v-on="on"
                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                        {{
                                            order.ROHrs
                                        }}
                                    </span>
                                </template>
                                <span>
                                    {{
                                        order.ROTime
                                    }}
                                </span>
                            </v-tooltip>
                        </td>
                        <td class="custom-cell">

                            <v-tooltip top>
                                <template v-slot:activator="{
                                    on,
                                    attrs
                                }">
                                    <span v-bind="attrs
                                        " v-on="on"
                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                        {{
                                            order.ETAHrs
                                        }}
                                    </span>
                                </template>
                                <span>
                                    {{
                                        order.ETATime
                                    }}
                                </span>
                            </v-tooltip>
                        </td>
                        <td class="custom-cell">
                            <span v-if="order.Finalize !== 1" class="small-text">
                                {{ order.EstimateTime }}
                            </span>
                            <v-icon v-else color="green">mdi-check</v-icon>
                        </td>
                    </tr>
                </draggable>
            </template>
        </v-data-table>

        <vue-context ref="openOrders" :style="{ top: `${menuY}px`, left: `${menuX}px` }">
            <template slot-scope="selectedOrder">
                <v-list dense style="margin:0px;padding:0px;">
                    <v-list-item-group color="primary">
                        <v-list-item @click="openEdit(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-pencil'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'View Order'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="splitOrder(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-call-split'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'Split Order'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="unSplitOrder(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-vector-line'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'Un-Split Order'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="preloadOrder(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-truck'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'Preload'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="unpreloadOrder(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-truck-outline'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'Un-Preload'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="showPaperwork(selectedOrder.data)">
                            <v-list-item-icon>
                                <v-icon v-text="'mdi-truck'"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="'Show PaperWork'"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </template>
        </vue-context>

        <AdviceDialog v-if="$store.state.dispatch.adviceDlg && adviceText" :text="adviceText" :order="orderN">
        </AdviceDialog>

        <AutoAssignQuantities v-if="selectedOrder && dialogs.autoAssignQuantities" :value="dialogs.autoAssignQuantities"
            @input="dialogs.autoAssignQuantities = $event" :orderId="selectedOrder.OrderID"
            :driverShiftId="selectedOrder.ShiftDetail" :stationId="selectedOrder.StationID" />
        <split v-if="dialogSplit" :dialogProp="dialogSplit" :ShiftDetail="shiftDetail.ShiftDetail" :loads="loadsSplits"
            @close="dialogSplit = false;" @save-close="splitsSave"></split>


        <SynchronizationWarning v-if="$store.state.dispatch.syncWarning" :Message="syncMessage">
        </SynchronizationWarning>
        <SwPaperWork v-if="showPaperworkByOrder" :showPaperworkByOrder="showPaperworkByOrder"
            :paperworkData="paperworkData" @close="showPaperworkByOrder = false;"></SwPaperWork>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import split from './SplitsModal.vue';
import SynchronizationWarning from '../../Modals/Dispatch/Dispatch/SynchronizationWarning.vue';
import AdviceDialog from '../../Modals/Dispatch/Advice/Advice.vue';

import VueContext from 'vue-context';
import { dataUtils } from '../../mixins/dataUtils.js';
import { dateUtils } from '../../mixins/dateUtils.js';

import AutoAssignQuantities from '../../Modals/Dispatch/Orders/AutoAssignQuantities.vue';
import axios from 'axios';
import SwPaperWork from './ShowPaperWork.vue';

export default {
    name: 'OrderTable',
    components: { VueContext, draggable, AutoAssignQuantities, split, SynchronizationWarning, SwPaperWork, AdviceDialog },
    props: ['orders', 'trailerAxles', 'shiftDetail'],
    mixins: [dataUtils, dateUtils],
    data() {
        return {
            indexDrag: null,
            orderGroup: {
                name: 'orders',
                pull: true,
                put: true
            },
            subMenu: [
                { text: 'Edit Order', icon: 'mdi-pencil' },
            ],
            OrderSelect: [],
            orderHeaders: [
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    width: '2%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Seq.',
                    value: 'LoadNum',
                    sortable: false,
                    width: '2%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Split',
                    value: 'LoadNumOrd',
                    sortable: false,
                    width: '2%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Order ID',
                    value: 'OrderID',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Terminal',
                    value: 'terminal',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Station',
                    value: 'station',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'City',
                    value: 'city',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'Quantity',
                    value: 'Qty',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'RT',
                    value: 'RT',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'RO',
                    value: 'RO',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'ETA',
                    value: 'ETA',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                },
                {
                    text: 'EH',
                    value: 'EH',
                    sortable: false,
                    width: '5%',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center',
                }
            ],
            trailerLimits: {
                6: 60000,
                5: 58000,
                4: 55000,
                3: 30000,
                1: 20000
            },
            dialogs: {
                autoAssignQuantities: false
            },
            selectedOrder: null,
            menuX: 0,
            menuY: 0,
            loadsSplits: [],
            dialogSplit: false,
            syncMessage: null,
            paperworkData: null,
            showPaperworkByOrder: false,
            adviceText: '',
            orderN: null
        };
    },
    mounted() {
    },
    methods: {

        showPaperwork: async function (order) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(order);
            let paperworkDataOrder = [];
            await axios
                .get('order/show-paperwork/' + order.OrderID)
                .then(response => {
                    console.log(response.data);
                    paperworkDataOrder = response.data;

                    if (paperworkDataOrder.length == 0) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This order has no paperwork scanned by the driver yet.'
                        });
                    } else {
                        this.paperworkData = paperworkDataOrder;
                        this.showPaperworkByOrder = true;
                    }
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        openOrderForm: function () {
            this.$store.state.order.add = true;
            this.back = true;
            this.$store.state.editedOrder.id = null;
            this.$store.state.editedOrder.StationID = null;
            this.$store.state.editedOrder.destiny = 1;
        },
        openContextMenu(order, evt) {
            this.orderClicked = order;
            this.menuX = evt.clientX;
            this.menuY = evt.clientY;
            this.$refs.openOrders.open(evt, order);
        },
        menuAction(option) {
            console.log("Opción seleccionada:", option);
            this.showContextMenu = false;
        },
        getOrderLoadStatus(order, type) {
            if (type === 'color') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'yellow darken-3';
                    }
                    case 'NOTSTARTED': {
                        return 'blue-grey lighten-2';
                    }
                    case 'INPROGRESS': {
                        return 'blue darken-2';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'green darken-1';
                    }
                    case 'DONE': {
                        return 'green darken-2';
                    }
                    case 'CANCELLED': {
                        return 'red darken-2';
                    }
                    default: {
                        return 'blue-grey lighten-2';
                    }
                }
            } else if (type === 'icon') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'mdi-email';
                    }
                    case 'NOTSTARTED': {
                        return 'mdi-circle-outline';
                    }
                    case 'INPROGRESS': {
                        return 'mdi-truck-fast';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'mdi-marker-check';
                    }
                    case 'DONE': {
                        return 'mdi-check-circle';
                    }
                    case 'CANCELLED': {
                        return 'mdi-cancel';
                    }
                    default: {
                        return 'mdi-help';
                    }
                }
            } else if (type === 'text') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'Ready to Send';
                    }
                    case 'INPROGRESS': {
                        return 'In Progress';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'Forced Completion';
                    }
                    case 'DONE': {
                        return 'Completed';
                    }
                    case 'CANCELLED': {
                        return 'Cancelled';
                    }
                    default: {
                        return 'Pending';
                    }
                }
            }
        },
        onDragEnd(event) {
            if (event.from !== event.to) {
                const order = event.item;
            }
        },
        getOrderQuantities(order) {
            if (!order.order_details || !Array.isArray(order.order_details)) {
                return 0; // Return 0 if order_details is not present or is not an array
            }

            // Use reduce to sum up DispatchedQuantity from each order detail
            return order.order_details.reduce((total, detail) => {
                // Check if product exists and if MaxCap == 1
                const dispatchedQuantity = detail.DispatchedQuantity || 0;
                const isLSD = detail.product && detail.product.MaxCap == 1;

                // Multiply by 1.14 if the product has MaxCap == 1 (LSD adjustment)
                const adjustedQuantity = isLSD
                    ? dispatchedQuantity * 1.14
                    : dispatchedQuantity;

                // Add the adjusted or non-adjusted dispatched quantity to the total
                return total + adjustedQuantity;
            }, 0);
        },
        closestRunout(order) {
            const orderDetails = order.order_details; // Properties: ProductType (product_id)
            const products = order.station.products; // Properties: product_id, safe_runout_at

            //Get the station product that is closest to runout and is present in the order details
            const closestProduct = products
                .filter(product =>
                    orderDetails.some(
                        detail => detail.ProductType == product.product_id
                    )
                )
                .sort((a, b) => {
                    const aRunout = a.safe_runout_at || Infinity;
                    const bRunout = b.safe_runout_at || Infinity;
                    return aRunout - bRunout;
                })[0];

            if (!closestProduct) {
                return null;
            }
            return closestProduct.safe_runout_at;
        },
        checkTrailerCapacity(loadedQuantity, type) {
            const capacity = this.trailerLimits[this.trailerAxles];
            if (!capacity) {
                console.error(
                    `Trailer capacity not found. Axles: ${this.trailerAxles} Quantity: ${loadedQuantity}`
                );
                return;
            }
            switch (type) {
                case 'color':
                    if (loadedQuantity > capacity) {
                        //Red pastel hex color code if the quantity is greater than the capacity
                        return '#000';
                    } else if (loadedQuantity == capacity) {
                        //Green pastel hex color code if the quantity is equal to the capacity
                        return '#000';
                    } else {
                        //Yellow pastel hex color code if the quantity is less than the capacity
                        return '#dda90d';
                    }
                case 'icon':
                    if (loadedQuantity > capacity) {
                        return 'mdi-truck-alert';
                    } else if (loadedQuantity == capacity) {
                        return 'mdi-truck-check';
                    } else {
                        return 'mdi-truck-fast';
                    }
                case 'text':
                    if (loadedQuantity > capacity) {
                        return 'Overloaded';
                    } else if (loadedQuantity == capacity) {
                        return 'Full';
                    } else {
                        return 'OK';
                    }
                case 'boolean':
                    return loadedQuantity >= capacity ? true : false;
                default:
                    console.error(`Invalid type: ${type}`);
                    return;
            }
        },
        openAutoAssignQuantities(order) {
            this.selectedOrder = order;
            this.dialogs.autoAssignQuantities = true;
        },
        orderColor(order) {
            if (order.ETATime > order.ROTime) {
                return '#FFCDD2'; // Red-ish color when ETATime is greater than ROTime
            } else if (order.ETATime < order.RTTime) {
                return '#FFF9C4'; // Yellow-ish color when ETATime is less than RTTime
            } else {
                return null; // Default color (same as second case in this example)
            }
        },
        async reorderLoads(bl) {
            let LoadNum = 1;
            let loadNumOrd = null;
            for (const index in this.orders) {
                if (index == 0) {
                    console.log(this.orders[index], index, 'First')
                    console.log(LoadNum, this.orders[index].LoadNum)
                    this.orders[index].LoadNum = LoadNum;
                    if (this.orders[index].LoadNumOrd != null) {
                        if (this.orders[index].LoadNumOrd == 1) {
                            loadNumOrd == this.orders[index].LoadNumOrd;
                        }
                        loadNumOrd++;
                        this.orders[index].LoadNumOrd = loadNumOrd;
                    } else {
                        loadNumOrd = null;
                        LoadNum++;
                    }
                } else {
                    // 
                    if (this.orders[index].LoadNumOrd != null) { // El Load Actual es Multiload
                        if (this.orders[index - 1].LoadNumOrd == null) { // Si el load anterior fue Single
                            // LoadNum++;
                            if (LoadNum == this.orders[index].LoadNum) { //El LoadNum es == al Actual
                                if (this.orders[index].loadNumOrd == 1) {
                                    LoadNum++;
                                    this.orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                } else {
                                    this.orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                }
                            } else {
                                if (this.orders[index].loadNumOrd == 1) {
                                    LoadNum++;
                                    this.orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                } else {
                                    this.orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                }
                            }
                        } else {
                            if (LoadNum == this.orders[index].LoadNum) {
                                this.orders[index].LoadNum = LoadNum;
                                loadNumOrd++;
                            } else {
                                if (this.orders[index].LoadNumOrd == 1) {
                                    LoadNum++;
                                    loadNumOrd = 1;
                                    this.orders[index].LoadNum = LoadNum;
                                    if (this.orders[(Number(index) + + 1)].LoadNumOrd != null) {
                                        this.orders[(Number(index) + + 1)].LoadNum = LoadNum;
                                    }
                                } else {
                                    this.orders[index].LoadNum = LoadNum;
                                    loadNumOrd++;

                                }
                            }
                        }
                        console.log(this.orders[index], 'Here')
                        if (typeof this.orders[(Number(index) + + 1)] !== 'undefined') {
                            if (this.orders[(Number(index) + + 1)].LoadNumOrd == null) {
                                console.log(this.orders[(Number(index) + + 1)], 'fined')
                                LoadNum++;
                            }
                        }
                        this.orders[index].LoadNumOrd = loadNumOrd;
                    } else {
                        this.orders[index].LoadNum = LoadNum;
                        loadNumOrd = null;
                        LoadNum++;
                    }
                }
            }
            if (bl) {
                const parms = await this.orders.map(x => {
                    return {
                        OrderID: x.OrderID,
                        LoadNum: x.LoadNum,
                        LoadNumOrd: x.LoadNumOrd
                    }
                })
                this.updateLoadNum(parms);
            }
        },
        updateLoadNum: function (parms) {
            axios
                .post('order/update/ordLoad/' + this.shiftDetail.ShiftDetail, parms)
                .then(response => {
                    console.log(response.data);
                    this.$emit('refreshPendingRevise', this.shiftDetail);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                    this.$emit('refreshLoads', 'updateActiveOrder')
                });
        },
        advice(station, terminal, order) {
            var str = this.$store;
            var parms = {
                terminalID: terminal,
                stationID: station
            };
            this.orderN = null;
            this.adviceText = '';
            axios
                .post('station-advice/advice', parms)
                .then(response => {
                    if (
                        response.data.stationDT.length > 0 ||
                        response.data.terinalDT.length > 0
                    ) {
                        this.orderN = order;
                        this.adviceText = response.data;
                        str.state.dispatch.adviceDlg = true;
                    }
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        addOrder: async function (evt) {
            this.$store.state.OnFrom = 'Shift';
            let str = this.$store;
            let shiftPrev = 0;
            await this.reorderLoads(0);
            const idx = await this.orders.findIndex(x => {
                return x.OrderStatus == "ACTIVE" && x.ShiftDetail == 0 || x.OrderStatus == "PRLDHELD" && x.ShiftDetail == 0
                    || x.OrderStatus == "DISPATCHED" && x.ShiftDetail != this.shiftDetail.ShiftDetail || x.OrderStatus == "PRLDISPAT" && x.ShiftDetail != this.shiftDetail.ShiftDetail;
            });
            if (this.orders[idx].ShiftDetail > 0) {
                shiftPrev = this.orders[idx].ShiftDetail;
            }
            let match = 1;
            if (this.orders[idx].isSpecific != this.shiftDetail.isSpecific) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'The specific product does not match'
                });
                match = 0;
            }
            if (this.orders[idx].OrderStatus == "PRLDHELD" || this.orders[idx].OrderStatus == "PRLDISPAT") {
                if (this.orders[idx].TrailerId != this.shiftDetail.trailer.TrailerId) {

                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'The trailer does not match'
                    });
                    match = 0;
                }
            }
            if (match) {
                if (this.orders[idx].OrderStatus == "ACTIVE") {
                    this.orders[idx].OrderStatus = "DISPATCHED";
                }
                else if (this.orders[idx].OrderStatus == "PRLDHELD" || this.orders[idx].OrderStatus == "PRLDISPAT")
                    this.orders[idx].OrderStatus = "PRLDISPAT";
                else {
                    this.orders[idx].OrderStatus = "DISPATCHED";
                    await this.reorderLoads(0);
                }
                const parms = {
                    LoadNum: this.orders[idx].LoadNum,
                    loadNumOrd: this.orders[idx].loadNumOrd,
                    OrdLoadStatus: this.orders[idx].OrdLoadStatus,
                    OrderStatus: this.orders[idx].OrderStatus,
                    ShiftDetail: this.shiftDetail.ShiftDetail
                }

                axios
                    .put('order/assign/' + this.orders[idx].OrderID, parms)
                    .then(response => {
                        console.log("response.data", response.data);
                        if (shiftPrev > 0) {
                            this.$store.state.removeOrderShift = shiftPrev;
                        }
                        this.advice(this.orders[idx].StationID, this.orders[idx].TerminalID, this.orders[idx].OrderID)
                        this.$emit('addOrder');
                        this.$emit('refreshPendingRevise', this.shiftDetail);
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
                console.log(parms);
            } else {
                if (shiftPrev > 0) {
                    this.$store.state.removeOrderShift = shiftPrev;
                }
                this.orders.splice(idx, 1);
                this.$emit('refreshLoads', 'just-refresh')
            }
        },
        removeOrder: async function () {
            if (this.$store.state.OnOrigin == "Shift") {
                if (this.OrderSelect.OrderStatus == "DISPATCHED") {
                    this.OrderSelect.OrderStatus = "ACTIVE";
                } else {
                    this.OrderSelect.OrderStatus = "PRLDHELD";
                }
                this.OrderSelect.LoadNum = null;
                this.OrderSelect.loadNumOrd = null;
                this.OrderSelect.OrdLoadStatus = "READYTOSEND";

                const parms = {
                    LoadNum: this.OrderSelect.LoadNum,
                    loadNumOrd: this.OrderSelect.loadNumOrd,
                    OrdLoadStatus: this.OrderSelect.OrdLoadStatus,
                    OrderStatus: this.OrderSelect.OrderStatus,
                    ShiftDetail: 0
                }
                await axios
                    .put('order/' + this.OrderSelect.OrderID, parms)
                    .then(() => {
                        this.$emit('addOrder');
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
                this.reorderLoads(1);
            }

        },
        onDragStart(event) {
            this.$store.state.OnOrigin = "Shift";
            this.OrderSelect = this.orders[event.oldDraggableIndex];
        },
        openEdit: function (order) {
            console.log("Triggered")
            this.$store.state.editedOrder.id = order.OrderID;
            this.$store.state.editedOrder.StationID = order.StationID;
            this.$store.state.editedOrder.destiny = 1;
            this.$store.state.order.edt = true;
        },
        splitOrder: function (x) {
            console.log('here', x)
            var str = this.$store;
            const origin = this.orders.findIndex(x => {
                return x.OrderID == this.orderClicked.OrderID;
            });
            console.log(origin);
            if (origin == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'A loadnum greater than 1 is required.'
                });
            } else {
                //Find loads when LoadNum is the same 
                const loads = this.orders.filter(x => {
                    return x.LoadNum == this.orders[origin - 1].LoadNum;
                })
                if (this.orders[origin].LoadNumOrd == null) {
                    loads.push(this.orderClicked);
                }
                this.loadsSplits = loads;
                this.dialogSplit = true;

            }
        },
        splitsSave: function () {
            this.reorderLoads(1);
            this.dialogSplit = false;
        },
        unSplitOrder: function (order) {
            var str = this.$store;
            order.SplitTypeID = null;
            order.LoadNum = order.LoadNum;
            order.LoadNumOrd = null;
            var parms = [{
                OrderID: order.OrderID,
                SplitTypeID: order.SplitTypeID,
                LoadNum: order.LoadNum,
                LoadNumOrd: order.LoadNumOrd
            }]

            str.state.isLoading = true;
            axios.post('order/update/split/' + this.shiftDetail.ShiftDetail, parms)
                .then(response => {
                    console.log(response.data);
                    this.reorderLoads(1);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        preloadOrder: async function (order) {
            let shiftDetail = this.shiftDetail.ShiftDetail;
            let shift = this.shiftDetail;
            let eleosCurrent = await this.checkForEleosCurrent(shiftDetail);
            console.log('Start');
            if (shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'preload'
                );
                if (isSynchronized) {
                    await this.preloadOrderInterface(
                        order,
                        0,
                        eleosCurrent,
                        1
                    );
                }
            } else {
                await this.preloadOrderInterface(order, 0, eleosCurrent, 1);
            }
        },
        unpreloadOrder: async function (order) {
            let shiftDetail = this.shiftDetail.ShiftDetail;
            let shift = this.shiftDetail;
            let eleosCurrent = await this.checkForEleosCurrent(shiftDetail);

            if (shift.DriverEleosApp == 1) {
                console.log('Sincronizando...');
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'un-preload'
                );
                if (isSynchronized) {
                    await this.unpreloadOrderInterface(
                        order,
                        0,
                        eleosCurrent,
                        1
                    );
                }
            } else {
                console.log('No existe en Eleos');
                await this.unpreloadOrderInterface(order, 0, eleosCurrent, 1);
            }
        },
        checkForEleosCurrent: async function (shiftDetail) {
            let resp;
            await axios
                .get('shift-detail/eleos-current-shift/' + shiftDetail)
                .then(response => {
                    console.log('checkForEleosCurrent: ', response.data);
                    resp = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            return resp;
        },
        checkSyncPlatforms: async function (fromId, toId, evt) {
            var str = this.$store;

            if (evt !== 'load-shifts') {
                this.$store.state.isLoading = true;
            }

            let params = {
                FromId: fromId,
                ToId: toId
            };

            let syncPlatformsData;
            await axios
                .post('shift-detail/sync-platforms', params)
                .then(response => {
                    console.log(response.data);
                    syncPlatformsData = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
            console.log(syncPlatformsData);

            // Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.
            if (evt == 'load-shifts') {
                console.log(
                    'Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.'
                );
                return;
            }

            if (syncPlatformsData == 'Synchronized') {
                // Things to do depending on the origin of the event
                if (
                    evt == 'view-order' ||
                    evt == 'preload' ||
                    evt == 'un-preload' ||
                    evt == 'split' ||
                    evt == 'un-split' ||
                    evt == 'tools' ||
                    evt == 'itself'
                ) {
                    return true;
                } else if (evt == 'refresh-orders') {
                    // let index = this.shiftDetails.indexOf(fromId);
                    console.log('test');
                    await this.getOrdersByShiftDetail(
                        fromId,
                        0,
                        '',
                        'just-refresh'
                    );
                }
            } else {
                for (let sh of syncPlatformsData) {
                    // let index = this.shiftDetails.indexOf(sh.ShiftDetail);
                    console.log('test');
                    await this.getOrdersByShiftDetail(
                        sh.ShiftDetail,
                        0,
                        sh.DriverName,
                        'synchronization'
                    );
                }

                if (evt == 'itself') {
                    return false;
                }
            }
        },
        getOrdersByShiftDetail: async function (
            shiftDetail,
            index,
            dvrName,
            instruction
        ) {
            var str = this.$store;
            this.$emit('refreshLoads')
            if (instruction == 'just-refresh') {
                str.dispatch('setSnackbar', {
                    color: '#1F618D',
                    text: 'Refreshing orders...'
                });
            } else if (instruction == 'synchronization') {
                if (dvrName !== '') {
                    this.syncMessage = [
                        `${dvrName}`,
                        ' has progressed in his Shift.',
                        'Your actions will not be executed.',
                        'Try it again after synchronization.',
                        'Synchronizing data with Eleos App...'
                    ];
                    this.$store.state.dispatch.syncWarning = true;
                }
            }

            await axios
                .post('order/shift/new/' + shiftDetail, {})
                .then(response => {
                    this.orders = response.data;
                    this.$emit('refreshLoads')
                })
                .catch(function (error) {
                    console.log(error);
                    this.$emit('refreshLoads')
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        preloadOrderInterface: async function (order, index, eleosCurrent, assign) {
            var str = this.$store;
            if (
                order.OrderStatus !== 'DISPATCHED' ||
                order.OrdLoadStatus === 'DONE' ||
                order.OrdLoadStatus === 'FORCEDCOMPLETION'
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'The selected order is not suitable for PRELOAD.'
                });
                return;
            }

            str.state.isLoading = true;
            await axios
                .get('order/preload/' + order.OrderID + '/' + assign)
                .then(async response => {
                    console.log(response.data);
                    this.$emit('refreshLoads');
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                });

            // }
        },
        unpreloadOrderInterface: async function (order, index, eleosCurrent) {
            var str = this.$store;
            this.$emit('refreshLoads');
            await axios
                .get('order/unpreload/' + order.OrderID)
                .then(async response => {
                    console.log(response.data);
                    this.$emit('refreshLoads');
                })
                .catch(function (error) {
                    this.$emit('refreshLoads');
                    console.log(error);
                });
        },
        onDragListener: function (evt) {
            console.log('hola', evt);
        }
    }
};
</script>

<style>
.location {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
}

.small-text {
    font-size: 0.7rem;
}

.custom-header {
    font-weight: bold;
    padding: 0 4px !important;
}

.custom-cell {
    padding: 0 4px !important;
    font-size: 0.7rem !important;
}

.ghost {
    opacity: 0;
    transition: opacity 0.1s ease;
    /* Ajusta la duración si necesitas más velocidad */
}
</style>
